import CurrencyValueUIModel from './currency-value';

class FareTotalUIModel {
  constructor({
    currency,
    points,
    upsellDifference,
  } = {}) {
    this.currency = new CurrencyValueUIModel(currency);
    this.points = points;
    this.upsellDifference = upsellDifference;
  }
}

export default FareTotalUIModel;
